import { MULTI_INJECT_TAG } from "../metadata_keys";

import { injectBase } from "./inject_base";

export const multiInject = injectBase(MULTI_INJECT_TAG);
//# sourceMappingURL=multi_inject.js.map
